import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

export const router = new Router({
  mode: 'history',
  linkExactActiveClass: 'is-active',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/Account/Login',
      name: 'login',
      meta: { template: 'no-sidebar', publicPath: true, unauthorized: true },
      component: () => import('./views/account/login/login.vue'),
    },
    {
      path: '/Account/ForgotPassword',
      name: 'forgot-password',
      meta: { template: 'no-sidebar', publicPath: true },
      component: () => import('./views/account/forgot-password/forgot-password.vue')
    },
    {
      path: '/Console',
      name: 'console',
      meta: { template: 'no-sidebar', rolePermission: true },
      component: () => import('./views/console/moderators-console/moderators-console.vue'),
    },
    {
      path: '/Console/AddService',
      name: 'add-service',
      meta: { template: 'no-sidebar', rolePermission: true },
      component: () => import('./views/console/add-service/add-service.vue'),
    },
    {
      path: '/Console/AddDetails',
      name: 'add-details',
      meta: { template: 'no-sidebar', rolePermission: true },
      component: () => import('./views/console/add-details/add-details.vue')
    },
    {
      path: '/Console/AddGoogleApiCertificate',
      name: 'add-google-certificate',
      meta: { template: 'no-sidebar', rolePermission: true },
      component: () => import('./views/console/add-google-certificate/add-google-certificate.vue')
    },
    {
      path: '/Console/UnregisteredUsers',
      name: 'unregistered-users',
      meta: { template: 'no-sidebar', rolePermission: true},
      component: () => import('./views/console/unregistered-users/unregistered-users.vue')
    },
    {
      path: '/Console/ManageKeywords',
      name: 'manage-keywords',
      meta: { template: 'no-sidebar', rolePermission: true },
      component: () => import('./views/console/manage-keywords/manage-keywords.vue')
    },
    {
      path: '/Console/ManageCategoryNames',
      name: 'manage-category-names',
      meta: { template: 'no-sidebar', rolePermission: true },
      component: () => import('./views/console/manage-cat-names/manage-cat-names.vue')
    },
    {
      path: '/Console/AddModerator',
      name: 'add-moderator',
      meta: { template: 'no-sidebar', rolePermission: true },
      component: () => import('./views/console/add-moderator/add-moderator.vue')
    },
    {
      path: '/Console/RemoveUser',
      name: 'remove-user',
      meta: { template: 'no-sidebar', rolePermission: true },
      component: () => import('./views/console/remove-user/remove-user.vue')
    },
    {
      path: '/Console/ManageEmailReceivers',
      name: 'manage-email-receivers',
      meta: { template: 'no-sidebar', rolePermission: true },
      component: () => import('./views/console/manage-email-receivers/manage-email-receivers.vue')
    },
    {
      path: '/Account/Register',
      name: 'register',
      meta: { template: 'no-sidebar', publicPath: true, activationCode: true },
      component: () => import('./views/account/register/register.vue'),
    },
    {
      path: '/Account/ResetPassword',
      name: 'reset-password',
      meta: { template: 'no-sidebar', publicPath: true, resetConfig: true },
      component: () => import('./views/account/reset-password/reset-password.vue'),
    },
    {
      path: '/',
      name: 'overview',
      component: () => import('./views/dashboard/overview/overview.vue'),
    },
    {
      path: '/Keywords/KeywordStatistics',
      name: 'statistics',
      component: () => import('./views/dashboard/keywords/statistics/statistics.vue'),
    },
    {
      path: '/Keywords/KeywordRankings',
      name: 'rankings',
      component: () => import('./views/dashboard/keywords/rankings/rankings.vue'),
    },
    {
      path: '/Keywords/CompetitorsDetails',
      name: 'competitors',
      component: () => import('./views/dashboard/keywords/competitors/competitors.vue')
    },
    {
      path: '/Analytic/Cities',
      name: 'cities',
      component: () => import('./views/dashboard/analytics/analytics-table.vue'),
    },
    {
      path: '/Analytic/Countries',
      name: 'countries',
      component: () => import('./views/dashboard/analytics/analytics-table.vue'),
    },
    {
      path: '/Analytic/Devices',
      name: 'devices',
      component: () => import('./views/dashboard/analytics/analytics-table.vue'),
    },
    {
      path: '/Analytic/Genders',
      name: 'genders',
      component: () => import('./views/dashboard/analytics/analytics-table.vue'),
    },
    {
      path: '/Analytic/Ages',
      name: 'ages',
      component: () => import('./views/dashboard/analytics/analytics-table.vue'),
    },
    {
      path: '/Analytic/Hours',
      name: 'hours',
      component: () => import('./views/dashboard/analytics/analytics-table.vue'),
    },
    {
      path: '/Analytic/Channels',
      name: 'channels',
      component: () => import('./views/dashboard/analytics/analytics-table.vue'),
    },
    {
      path: '/Analytic/Campaigns',
      name: 'campaigns',
      component: () => import('./views/dashboard/analytics/analytics-table.vue'),
    },
    {
      path: '/Manage/ToDoList',
      name: 'to-do-list',
      // component:
    },
    {
      path: '/Support',
      name: 'support',
      // component:
    },
    {
      path: '/Manage/AccountSettings',
      name: 'settings',
      component: () => import('./views/dashboard/manage/manage.vue'),
    },
    {
      path: '/Account/Logout',
      name: 'logout',
      meta: { logout: true },
    },
    {
      path: "*",
      name: '404', 
      // component: PageNotFound
    }
  ]
});

router.beforeEach((to, from, next) => {

  if (to.matched.some(record => !record.meta.publicPath)) {

    if (!store.getters['Token']) {

      return next({name: 'login'});
    }
  }

  if (to.matched.some(record => record.meta.rolePermission)) {

    if (!store.getters['Moderator']) {

      return next({name: 'overview'});
    }
  }

  if (to.matched.some(record => record.meta.activationCode)) {

    if (to.query.activationCode && !store.getters['Authenticated']) {

      return next();
    }

    return next({name: 'overview'});
  }

  if (to.matched.some(record => record.meta.resetConfig)) {
    
    if (to.query.username && to.query.token && !store.getters['Authenticated']) {
      
      return next();
    }

    return next({name: 'overview'});
  }

  if (to.matched.some(record => record.meta.unauthorized)) {

    if (store.getters['Authenticated']) {

      return next({name: 'overview'});
    }
  }

  if (to.matched.some(record => record.meta.logout)) {

    store.commit('destroySession');

    if (to.name != 'login') {

      return next({name: 'login'});
    }
  }

  return next();
});